class Campaign {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.wrap = this.el.querySelector(".campaign__range-wrap");
        this.range = this.el.querySelector(".campaign__range");
        this.thumb = this.el.querySelector(".campaign__thumb-visual");
        this.ticks = this.el.querySelectorAll(".campaign__tick");
        this.slides = this.el.querySelectorAll(".campaign__slide");
        this.donationInput = this.el.querySelector("[data-custom-donation-input]");
        this.customInput = this.el.querySelector('input[name="custom-amount"]');
        this.amounts = this.el.querySelectorAll(".campaign__amount");
        this.texts = this.el.querySelectorAll(".campaign__text");

        if (!this.range || !this.ticks.length) return;

        this.range.addEventListener("input", () => this.update());

        if (this.customInput) {
            this.customInput.addEventListener("input", () => this.updateCustomAmount());
        }

        setTimeout(() => this.update(), 50);

        this.el._campaign = this;
    }

    update() {
        const i = Number(this.range.value);
        const amount = this.ticks[i] ? this.ticks[i].getAttribute("data-value") : "";

        this.ticks.forEach((t, j) => t.classList.toggle("active", j === i));
        this.slides.forEach((s, j) => s.classList.toggle("active", j === i));

        if (this.amounts[i]) {
            this.amounts[i].textContent = `£${amount}`;
        }
        if (this.texts[i]) {
            this.texts[i].style.visibility = "";
        }
        if (this.customInput) {
            this.customInput.value = "";
        }

        if (this.donationInput) {
            this.donationInput.value = amount || "0";
            this.donationInput.dispatchEvent(new Event("input", { bubbles: true }));
        }

        const tick = this.ticks[i];
        if (tick && this.thumb && this.wrap) {
            const wr = this.wrap.getBoundingClientRect();
            const tr = tick.getBoundingClientRect();
            this.thumb.style.left = tr.left - wr.left + "px";
            this.thumb.style.width = tick.offsetWidth + "px";
        }
    }

    updateCustomAmount() {
        const val = this.customInput.value.trim();
        const i = Number(this.range.value);
        if (this.amounts[i]) {
            const defaultAmount = this.ticks[i] ? this.ticks[i].getAttribute("data-value") : "";
            this.amounts[i].textContent = val ? `£${val}` : `£${defaultAmount}`;
        }
        if (this.texts[i]) {
            this.texts[i].style.visibility = val ? "hidden" : "";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll(".campaign-donate");
    containers.forEach((el) => new Campaign(el));

    window.addEventListener("resize", () => {
        setTimeout(() => {
            containers.forEach((el) => {
                if (el._campaign) el._campaign.update();
            });
        }, 50);
    });

    window.addEventListener("pageshow", () => {
        containers.forEach((el) => {
            if (el._campaign) el._campaign.update();
        });
    });
});

export default Campaign;